/* The MZR Elite Shopify Native Theme Engine JS - Performance & Touch Optimized */

(function() {
  'use strict';

  // 1. High Performance 3D Tilt Effect (rAF Throttled + Mobile Touch Elevation)
  function init3DTilt() {
    const cards = document.querySelectorAll('.hover-lift-3d');
    if (!cards.length) return;

    const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

    cards.forEach(card => {
      if (card.parentElement && !card.parentElement.classList.contains('perspective-container')) {
        card.parentElement.classList.add('perspective-container');
      }

      if (isTouchDevice) {
        // Mobile Touch Feedback - Elevation on Touch
        card.addEventListener('touchstart', function() {
          this.style.transition = 'transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.2s cubic-bezier(0.16, 1, 0.3, 1)';
          this.style.transform = 'perspective(1000px) translateY(-8px) scale(1.02)';
          this.style.boxShadow = '0 25px 50px -10px rgba(212, 175, 55, 0.3), 0 10px 25px -5px rgba(0, 0, 0, 0.2)';
        }, { passive: true });

        card.addEventListener('touchend', function() {
          this.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
          this.style.transform = 'perspective(1000px) translateY(0px) scale(1)';
          this.style.boxShadow = '0 15px 35px -10px rgba(0, 0, 0, 0.06)';
        }, { passive: true });

        card.addEventListener('touchcancel', function() {
          this.style.transform = 'perspective(1000px) translateY(0px) scale(1)';
          this.style.boxShadow = '0 15px 35px -10px rgba(0, 0, 0, 0.06)';
        }, { passive: true });

      } else {
        // Desktop Mouse Move - Hardware Accelerated & Throttled via requestAnimationFrame
        let ticking = false;
        let mouseX = 0;
        let mouseY = 0;

        card.addEventListener('mousemove', function(e) {
          const rect = this.getBoundingClientRect();
          mouseX = e.clientX - rect.left;
          mouseY = e.clientY - rect.top;

          if (!ticking) {
            window.requestAnimationFrame(() => {
              const centerX = rect.width / 2;
              const centerY = rect.height / 2;
              const rotateX = ((mouseY - centerY) / centerY) * -10;
              const rotateY = ((mouseX - centerX) / centerX) * 10;

              card.style.transition = 'none';
              card.style.transform = `perspective(1000px) rotateX(${rotateX.toFixed(2)}deg) rotateY(${rotateY.toFixed(2)}deg) translateY(-12px) scale(1.03)`;
              card.style.boxShadow = '0 30px 65px -15px rgba(0, 0, 0, 0.25), 0 0 25px rgba(212, 175, 55, 0.3)';
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });

        card.addEventListener('mouseleave', function() {
          this.style.transition = 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
          this.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) translateY(0px) scale(1)';
          this.style.boxShadow = '0 15px 35px -10px rgba(0, 0, 0, 0.06)';
        }, { passive: true });
      }
    });
  }

  // 2. Interactive Product Carousel Slider with Touch Swipe & Drag
  function initMzrSlider() {
    const track = document.getElementById('mzr-slider-track');
    const prevBtn = document.getElementById('mzr-slider-prev');
    const nextBtn = document.getElementById('mzr-slider-next');
    const dots = document.querySelectorAll('.mzr-slider-dot');
    
    if (!track) return;

    let currentIndex = 0;
    const slides = track.children;
    const totalSlides = slides.length;
    let autoPlayTimer = null;

    function getSlideWidth() {
      if (!slides[0]) return 260;
      const style = window.getComputedStyle(slides[0]);
      const margin = parseFloat(style.marginRight) || 24;
      return slides[0].offsetWidth + margin;
    }

    function updateSlider(index, animate = true) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentIndex = index;

      const slideWidth = getSlideWidth();
      if (animate) {
        track.style.transition = 'transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)';
      } else {
        track.style.transition = 'none';
      }
      track.style.transform = `translate3d(-${currentIndex * slideWidth}px, 0, 0)`;

      dots.forEach((dot, idx) => {
        if (idx === currentIndex) {
          dot.classList.add('bg-amber-500', 'w-8');
          dot.classList.remove('bg-zinc-300', 'w-2');
        } else {
          dot.classList.remove('bg-amber-500', 'w-8');
          dot.classList.add('bg-zinc-300', 'w-2');
        }
      });
    }

    // Touch & Drag Gesture Engine for Mobile & Desktop
    let startX = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let isDragging = false;
    let touchStartTime = 0;

    function touchStart(e) {
      isDragging = true;
      startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      touchStartTime = Date.now();
      prevTranslate = -currentIndex * getSlideWidth();
      stopAutoPlay();
      track.style.transition = 'none';
    }

    function touchMove(e) {
      if (!isDragging) return;
      const currentPositionX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
      const diffX = currentPositionX - startX;
      currentTranslate = prevTranslate + diffX;
      track.style.transform = `translate3d(${currentTranslate}px, 0, 0)`;
    }

    function touchEnd(e) {
      if (!isDragging) return;
      isDragging = false;
      const endX = e.type.includes('touch') ? (e.changedTouches[0] ? e.changedTouches[0].clientX : startX) : e.clientX;
      const movedBy = endX - startX;
      const timeTaken = Date.now() - touchStartTime;

      if (movedBy < -40 || (movedBy < -15 && timeTaken < 250)) {
        updateSlider(currentIndex + 1);
      } else if (movedBy > 40 || (movedBy > 15 && timeTaken < 250)) {
        updateSlider(currentIndex - 1);
      } else {
        updateSlider(currentIndex);
      }
      startAutoPlay();
    }

    track.addEventListener('touchstart', touchStart, { passive: true });
    track.addEventListener('touchmove', touchMove, { passive: true });
    track.addEventListener('touchend', touchEnd, { passive: true });
    track.addEventListener('touchcancel', touchEnd, { passive: true });

    track.addEventListener('mousedown', touchStart);
    track.addEventListener('mousemove', touchMove);
    track.addEventListener('mouseup', touchEnd);
    track.addEventListener('mouseleave', touchEnd);

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        updateSlider(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        updateSlider(currentIndex + 1);
      });
    }

    dots.forEach((dot, idx) => {
      dot.addEventListener('click', () => updateSlider(idx));
    });

    function startAutoPlay() {
      stopAutoPlay();
      autoPlayTimer = setInterval(() => updateSlider(currentIndex + 1), 4500);
    }
    function stopAutoPlay() {
      if (autoPlayTimer) clearInterval(autoPlayTimer);
    }

    track.addEventListener('mouseenter', stopAutoPlay, { passive: true });
    track.addEventListener('mouseleave', startAutoPlay, { passive: true });
    startAutoPlay();
  }

  // 3. Quick View Modal Handler
  window.mzrOpenQuickView = function(variantId, title, price, image, vendor, description, productUrl, isAvailable) {
    const modal = document.getElementById('mzr-quick-modal');
    if (!modal) return;

    if (variantId) {
      const variantInput = document.getElementById('mzr-modal-variant-id');
      if (variantInput) variantInput.value = variantId;
    }

    const titleEl = document.getElementById('mzr-modal-title');
    const priceEl = document.getElementById('mzr-modal-price');
    const imgEl = document.getElementById('mzr-modal-img');
    const vendorEl = document.getElementById('mzr-modal-vendor');
    const descEl = document.getElementById('mzr-modal-desc');
    const buyLink = document.getElementById('mzr-modal-buy-link');
    const stockBadge = document.getElementById('mzr-modal-stock-badge');
    const addBtn = document.getElementById('mzr-modal-add-btn');

    if (titleEl) titleEl.textContent = title || '';
    if (priceEl) priceEl.textContent = price || '';
    if (imgEl) imgEl.src = image || '';
    if (vendorEl) vendorEl.textContent = vendor || 'THE MZR ELITE';
    if (descEl) descEl.textContent = description || '';
    if (buyLink) buyLink.href = productUrl || '/checkout';

    const available = isAvailable !== undefined ? Boolean(isAvailable) : true;
    if (stockBadge) {
      if (available) {
        stockBadge.textContent = 'In Stock';
        stockBadge.className = 'text-xs text-emerald-600 font-bold bg-emerald-500/10 px-3 py-1 rounded-full';
      } else {
        stockBadge.textContent = 'Sold Out';
        stockBadge.className = 'text-xs text-rose-500 font-bold bg-rose-500/10 px-3 py-1 rounded-full';
      }
    }

    if (addBtn) {
      if (available) {
        addBtn.disabled = false;
        addBtn.style.opacity = '1';
        addBtn.style.cursor = 'pointer';
        const span = addBtn.querySelector('span');
        if (span) span.textContent = 'Add to Cart';
      } else {
        addBtn.disabled = true;
        addBtn.style.opacity = '0.5';
        addBtn.style.cursor = 'not-allowed';
        const span = addBtn.querySelector('span');
        if (span) span.textContent = 'Sold Out';
      }
    }

    if (buyLink) {
      if (available) {
        buyLink.style.pointerEvents = 'auto';
        buyLink.style.opacity = '1';
      } else {
        buyLink.style.pointerEvents = 'none';
        buyLink.style.opacity = '0.5';
      }
    }

    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  };

  window.mzrCloseQuickView = function() {
    const modal = document.getElementById('mzr-quick-modal');
    if (modal) {
      modal.classList.add('hidden');
      document.body.style.overflow = '';
    }
  };

  // 4. Shopify Inbox / Direct WhatsApp Contact Handler
  window.mzrOpenOnlineStoreChat = function(productTitle, variantTitle) {
    const inquiryText = `Hi! I am inquiring about "${productTitle || 'this item'}" ${variantTitle ? `(${variantTitle})` : ''}. Could you please confirm details?`;

    if (window.ShopifyInbox && typeof window.ShopifyInbox.open === 'function') {
      window.ShopifyInbox.open();
      return;
    } 
    if (window.ShopifyChat && typeof window.ShopifyChat.open === 'function') {
      window.ShopifyChat.open();
      return;
    }

    const chatBtn = document.querySelector('#shopify-chat-iframe, iframe[src*="shopify_chat"], .shopify-chat-button, [data-shopify-chat]');
    if (chatBtn) {
      chatBtn.click();
      return;
    }

    window.open('https://wa.me/923227676088?text=' + encodeURIComponent(inquiryText), '_blank');
  };

  function initAll() {
    init3DTilt();
    initMzrSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();